const p = _ref => {
  let {
    isOpen: e,
    state: s,
    items: o,
    filterTerm: i,
    filteredItems: n,
    noMatchMessage: a,
    stateMessage: t,
    caption: l
  } = _ref;
  const c = e && !s && o.length > 0,
    g = e && i && n.length === 0,
    r = s === "error";
  return {
    showDropdownList: c,
    isError: r,
    messageHelpText: g ? a : r && t ? t : l
  };
};
export { p as useVerification };